import React, { Component } from "react";
import "./pillcard.css";

export default class Classcard extends Component {
  removePillcardHandler = () => {
    this.props.removePillcardHandler(this.props.classcardobj, false);
  };

  render() {
    let { classcardobj, language } = this.props;
    return (
      <div className="pillcard">
        <div className="head center-children">
          <span className="pill-name">
            {language === "eng"
              ? classcardobj.Med_Class
              : classcardobj.Med_Class_es}
            <button
              className="close"
              onClick={this.removePillcardHandler}
              type="button"
            />
          </span>
          <span className="pill-name-details">
            {language === "eng"
              ? classcardobj.Method_of_Action
              : classcardobj.Method_of_Action_es}
          </span>
        </div>
        <div className="content">
          <div className="side-effect">
            <div className="side-effect-name">Pros</div>
            <div className="side-effect-stats">
              {language === "eng" ? classcardobj.Pros : classcardobj.Pros_es}
            </div>
          </div>
          <div className="side-effect">
            <div className="side-effect-name">Cons</div>
            <div className="side-effect-stats">
              {language === "eng" ? classcardobj.Cons : classcardobj.Cons_es}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CarouselElements/Classcard.js